module.exports = __webpack_public_path__ + "static/media/modal-dismiss-icon.53d9c825.svg";